import { Injectable } from '@angular/core';

import { AppState } from '../../core/app-state';
import { RestClient } from '../../core/services/rest-client';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import {Volunteer} from "../models/volunteer";
import { VolunteerHandsetRec } from '../models/volunteer-handset';

// Need rest connection to deal with saving user data since password is involved
@Injectable({ providedIn: 'root' })
export class VolunteerService extends RestClient<Volunteer> {

    constructor( http: HttpClient, appState : AppState ) {
        super(http, 'volunteers', appState)
    }

    create( volunteer : Volunteer,accessiblePoints ) {
        console.log('Creating volunteer ' + JSON.stringify(volunteer))
        return firstValueFrom(
            this.http.post(this.urlPath, {volunteer:volunteer,accessiblePoints:accessiblePoints}, { observe: 'response' })
        );
    }


    update( volunteer : Volunteer,accessiblePoints ) {
        return firstValueFrom(
            this.http.patch(this.urlPath, {volunteer:volunteer,accessiblePoints:accessiblePoints}, { observe: 'response' })
        );
    }

    deleteUserById( volunteerId : string ) : Promise<HttpResponse<any>> {
        console.log('Deleting volunteer.  ID="' + volunteerId + '"')
        if ( volunteerId === null ) {
            throw new Error('No ID set for delete volunteer action.');
        }
        return firstValueFrom(this.http.delete(this.urlPath + '/' + volunteerId, { observe: 'response' }));
    }

    async getVolunteers():Promise<Volunteer[]>
    {
        const result = await firstValueFrom(this.http.get(this.urlPath,{observe:'response'}));
        console.log('getVolunteers()', result);
        return result.body as Volunteer[];
    }

    //TODO - add correct types... server response is merged handset and point data with VolunteerEntity :-(
    async getByIdEagerly( volunteerId: string ) {
        const populateChildren = true // need points, etc...
        const results = await this.find({filters:[{key: 'id', value: volunteerId, mode: '=' }]}, populateChildren);
        return results.rows[0];
    }

    async findByBuildingId(buildingId: string) {
        try {
            const result: any = await firstValueFrom(
                this.http.get(`${this.urlPath}/findByBuildingId/${buildingId}`)
            );
            const resp : Volunteer[] = result.data;
            console.dir(resp)
            return resp;
        } catch (error) {
            console.error("findByBuildingId() error: " + error?.message);
            throw error;
        }
    }

    async findByTestbedPointIds(testbedPointIds: string[]) {
        try {
            const result: any = await firstValueFrom(
                this.http.get(`${this.urlPath}/findByTestbedPointIds`, { params: {
                    testbedPointIds
                }})
            );
            const resp : Volunteer[] = result.data;
            console.dir(resp)
            return resp;
        } catch (error) {
            console.error("findByTestbedPointId() error: " + error?.message);
            throw error;
        }
    }


    patchHandset( handset: Partial<VolunteerHandsetRec> ) {
        return firstValueFrom(            
            this.http.patch<VolunteerHandsetRec>(this.urlPath + '/handset', {...handset})
        );
    }

}